module.exports = __webpack_public_path__ + "img/avatar-user-saas.358913cd.png";